{
  "account": {
    "title": "Il Mio Account",
    "list": {
      "title": "Account",
      "description": "Elenco fatture account collegati"
    },
    "form": {
      "name": {
        "title": "Nome",
        "description": "Il tuo nome account"
      },
      "password": {
        "title": "Password",
        "description": "Imposta una nuova password per il tuo account, lascia vuoto per mantenere la password attuale"
      },
      "emailPreferences": {
        "title": "Preferenze e-mail",
        "description": "Seleziona i tipi di notifica via e-mail"
      }
    },
    "billing": "Dettagli di fatturazione",
    "subscriptions": "Iscrizioni",
    "manageSubscription": "Gestisci iscrizioni",
    "popup": {
      "downgrade": "Sei sicuro di eseguire il downgrade? Il downgrade sarà effettivo immediatamente.<br/>Tieni presente che non avrai diritto a uno sconto per il tempo rimanente del ciclo di fatturazione corrente.<br/>Il prezzo del nuovo piano verrà applicato al ciclo di fatturazione successivo.",
      "default": "Sei sicuro di voler cambiare il tuo piano?",
      "cancel": "Sei sicuro di voler cancellare il tuo abbonamento?<br/> Il tuo sito web continuerà a essere tradotto fino alla fine del periodo di abbonamento attuale. Successivamente, la traduzione verrà disabilitata.<br/> Tieni presente che non avrai diritto a uno sconto per il periodo non utilizzato.",
      "resume": "Vuoi davvero riprendere il tuo abbonamento?"
    }
  },
  "ai_translation": {
    "header": "Traduzione AI",
    "plan": {
      "header": "Prezzi delle traduzioni AI",
      "used": "Hai utilizzato {words_used} / {words_allowed} parole tradotte nei tuoi crediti AI.",
      "remaining": "Crediti AI disponibili:",
      "words": "parole",
      "add_more_credits": "Aggiungi altri crediti AI",
      "details": {
        "idiomatic_expressions": "Espressioni idiomatiche e tecniche",
        "background_translation": "Traduzioni in background",
        "page_context": "Contesto della pagina e del sito web per la traduzione",
        "perfect_quality": "Qualità perfetta, prezzo accessibile",
        "no_recurring": "Nessun pagamento ricorrente, quota prepagata",
        "save_40": "Risparmia il 40% rispetto al piano da $20",
        "save_50": "Risparmia il 50% rispetto al piano da $20",
        "best_website": "Sito web che richiede una qualità di traduzione perfetta"
      },
      "quota": "{estimated_words} parole ~ {estimated_pages} pagine"
    },
    "settings": {
      "banner": {
        "title": "Traduzione AI Linguise",
        "intro": "Linguise è lieta di presentare Linguise AI Translation, una nuova funzionalità premium che sfrutta i modelli AI LLM (i modelli Llama più recenti, ottimizzati per le attività di traduzione). Progettata per i siti web che richiedono un'accuratezza impeccabile, considera sia il contesto della pagina che quello dell'intero sito web per risultati senza pari. Offrite ai vostri clienti il ​​massimo della qualità di traduzione, assicurando che il loro messaggio risuoni perfettamente in ogni lingua.",
        "button": "Aggiorna ora"
      },
      "alert": {
        "description": "Questa funzionalità non è inclusa nel tuo piano attuale e richiede un acquisto separato. Attiva questo componente aggiuntivo per sbloccare tutte le opzioni elencate di seguito."
      },
      "languages": {
        "title": "Applicare la traduzione AI alle lingue",
        "description": "Seleziona la lingua specifica in cui desideri applicare la traduzione AI"
      },
      "button": {
        "save": "Salva le impostazioni"
      },
      "form": {
        "rule_application": {
          "description": "Applica la traduzione AI su contenuti statici o dinamici o entrambi",
          "title": "Applica al contenuto",
          "all": "Tutti i contenuti",
          "static": "Contenuto statico",
          "dynamic": "Contenuto dinamico"
        },
        "website_topic": {
          "title": "Argomento del sito web",
          "placeholder": "Ristorante di sushi...",
          "description": "Definisci l'argomento del tuo sito web per una migliore qualità di traduzione (ad es. Legale, ristorante di sushi, negozio di ricambi per biciclette...).\nInserisci l'argomento del sito web in inglese."
        },
        "apply_to_urls": {
          "title": "Applica agli URL",
          "description": "Seleziona URL specifici in cui desideri applicare la traduzione AI",
          "all_urls": "Tutti gli URL",
          "selected_urls": "URL selezionati",
          "label": "URL a cui fare domanda",
          "placeholder": "URL a cui fare domanda",
          "wildcard": "Carattere jolly",
          "regex": "Espressione regolare",
          "add": "Aggiungi nuovo",
          "expression": "Tipo di espressione"
        },
        "apply_languages": {
          "title": "Applica alle lingue",
          "description": "Seleziona la lingua specifica in cui desideri applicare la traduzione AI",
          "all_languages": "Tutte le lingue",
          "selected_languages": "Lingue selezionate",
          "placeholder": "Seleziona le lingue...",
          "feedback": "Devi scegliere una lingua"
        },
        "enable_mode": {
          "title": "ABILITA LA TRADUZIONE AI",
          "description": "Scegli come desideri abilitare la traduzione AI.\nSaranno applicate solo le seguenti regole.\nSolo l'editor live consentirà di abilitare la traduzione pagina per pagina dalla vista dell'editor live.\nLe regole e l'editor live utilizzeranno entrambe le funzionalità.",
          "disabled": "Disabili",
          "rules": "Solo regole",
          "live_editor": "Solo editor live",
          "all": "Regole ed editor live"
        },
        "formality": {
          "title": "Formalità",
          "description": "Specificare il grado di formalità nelle traduzioni, potenzialmente importante per il pubblico e il contesto.\n\"Neutro\" cercherà di preservare la formalità del contenuto originale.\n\"Formale\" si riferisce a contenuti professionali, commerciali o legali (ad esempio, l'uso di pronomi formali come \"usted\" in spagnolo).\n\"Informale\" si riferisce a contenuti informali e colloquiali (ad esempio, l'uso di \"tú\" in spagnolo).",
          "neutral": "Neutro",
          "formal": "Formale",
          "informal": "Informale"
        },
        "sentence_structure": {
          "classic": "Classico",
          "short": "Frasi brevi e incisive",
          "detailed": "Frasi dettagliate ed esplicative",
          "title": "Struttura della frase",
          "description": "Definisci lo stile di scrittura preferito."
        },
        "content_purpose": {
          "marketing": "Marketing/promozionale (tono persuasivo e coinvolgente)",
          "technical": "Tecnico/istruttivo (chiaro, preciso, orientato all'azione)",
          "support": "Assistenza clienti (empatia, disponibilità, rassicurazione)",
          "legal": "Legale/conformità (preciso, formale, inequivocabile)",
          "educational": "Educativo (chiaro, strutturato, accessibile)",
          "title": "Scopo del contenuto",
          "description": "Definire lo scopo funzionale del contenuto tradotto.",
          "other_placeholder": "Descrivi lo scopo...",
          "other": "Altro (in inglese)"
        },
        "target_audience": {
          "title": "Pubblico di destinazione",
          "description": "Specificazione del pubblico a cui è destinato il contenuto tradotto (in inglese).",
          "placeholder": "ad esempio, genitori di lingua spagnola, responsabili della privacy dell'UE"
        },
        "advanced": {
          "title": "Istruzioni AI avanzate",
          "description": "Istruzioni AI avanzate"
        },
        "override_default_translations": {
          "title": "Sostituisci la traduzione predefinita",
          "description": "Se impostata su SÌ, questa opzione forzerà la traduzione del contenuto con l'intelligenza artificiale (Linguise AI) anche se è già stato tradotto tramite la traduzione Cloud AI (modello di traduzione predefinito)."
        },
        "force_replace_before": {
          "title": "Forza la ritraduzione con l’IA",
          "description": "Traduci di nuovo con l’IA tutti i contenuti la cui traduzione IA è stata creata prima della data selezionata, ad esempio i contenuti tradotti con un modello precedente. La ritraduzione avverrà alla prossima visita delle pagine interessate secondo le regole e userà i crediti IA.",
          "before_date": "Prima di una data"
        },
        "model": {
          "current": "Corrente",
          "title": "Modello",
          "description": "Seleziona il modello di traduzione LLM che desideri utilizzare",
          "load_error": "Impossibile caricare i modelli disponibili. Si prega di riprovare più tardi.",
          "thinking_warning": "Questo modello utilizza un alto livello di ragionamento (\"pensiero\") e consumerà significativamente più token per traduzione."
        },
        "override_manual_and_selected": {
          "no_default": "No (predefinito)",
          "title": "Sovrascrivi le traduzioni manuali e selezionate",
          "description": "Per impostazione predefinita, una traduzione modificata manualmente resta sempre sul tuo sito, anche dopo la generazione di una traduzione migliorata con l'AI. Imposta su SÌ per mostrare invece la traduzione migliorata con l'AI. Le tue traduzioni manuali vengono conservate e puoi tornare indietro in qualsiasi momento. Questo vale anche quando traduci nuovamente le pagine per ottenere nuove traduzioni: verrà utilizzata automaticamente quella più recente."
        }
      },
      "message": {
        "save_success": "Considerando i contenuti già tradotti, il numero di pagine che verrebbero migliorate con la traduzione AI è di circa {{ai_affected_urls}}.",
        "save_success_only": "Impostazioni salvate correttamente."
      }
    },
    "pricing": {
      "plan": {
        "title": "Ordina la quota di traduzione AI",
        "buy_button": "ACQUISTA IL PACCHETTO DI TRADUZIONE AI"
      },
      "modal": {
        "title": "Conferma la modifica del piano",
        "description": "Sei sicuro di voler modificare il tuo piano di traduzione AI?",
        "button_cancel": "Cancellare",
        "button_confirm": "Confermare",
        "loading": "Attendere prego...",
        "amount": "Quantità",
        "credit": "Credito",
        "total_due": "Totale dovuto"
      },
      "comparison": {
        "title": "Traduzione AI di Google Cloud vs traduzione AI di Linguise",
        "list": {
          "0": {
            "google": "Traduzioni veloci e affidabili",
            "linguise": "Gestire espressioni idiomatiche e tecniche"
          },
          "1": {
            "google": "Traduzioni istantanee di tutte le pagine del sito web",
            "linguise": "Generazione delle traduzioni in background"
          },
          "2": {
            "google": "Migliore qualità, prezzo basso",
            "linguise": "Qualità perfetta, prezzo accessibile"
          },
          "3": {
            "google": "Ideale per siti web di grandi dimensioni o budget ridotti",
            "linguise": "Ideale per i siti web che richiedono una qualità di traduzione perfetta"
          },
          "4": {
            "google": "Contesto della pagina per la traduzione",
            "linguise": "Contesto della pagina e del sito web per la traduzione"
          }
        }
      },
      "botom_banner": {
        "title": "Prova una precisione di traduzione senza pari con",
        "sub_title": "Nuova traduzione Linguise AI",
        "description": "Linguise sta potenziando i suoi servizi di traduzione automatica con l'introduzione di Linguise AI Translation, una nuova e potente opzione che utilizza l'innovativa traduzione LLM basata sull'intelligenza artificiale (i più recenti modelli Llama ottimizzati per le traduzioni). Questa aggiunta offre agli sviluppatori di siti web e alle agenzie web un livello di qualità di traduzione ancora più elevato, ideale per progetti in cui la perfezione è fondamentale. Linguise AI Translation integra la nostra attuale traduzione AI di alta qualità basata su Google Cloud, offrendo maggiore flessibilità e precisione."
      }
    },
    "success": {
      "tab_title": "Grazie per aver acquistato il piano AI Translation!",
      "title": "Grazie per aver acquistato il piano AI Translation!",
      "subtitle": "Il tuo piano di traduzione AI è stato acquistato con successo!",
      "message": "Puoi gestire il tuo piano di traduzione AI nella pagina delle impostazioni di traduzione AI.",
      "home": "Gestire la traduzione AI"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "Nome",
        "description": "Nome account di fatturazione"
      },
      "phone": {
        "title": "Telefono",
        "description": "Telefono per la fatturazione"
      },
      "email": {
        "title": "E-mail",
        "description": "E-mail dell'account di fatturazione"
      },
      "address": {
        "title": "Indirizzo",
        "description": "Indirizzo dell'account di fatturazione",
        "city": "Città",
        "country": "Paese",
        "address1": "Indirizzo 1",
        "address2": "Indirizzo 2",
        "postal": "Codice postale",
        "state": "Stato"
      },
      "tax": {
        "title": "Codice fiscale"
      }
    }
  },
  "checkouts": {
    "header": "Guardare",
    "payment_method": "Seleziona il metodo di pagamento",
    "stripe_card": "Carta di credito (Stripe)",
    "paypal": "PayPal",
    "address": {
      "new": "Inserisci il nuovo indirizzo di fatturazione",
      "existing": "Utilizza l'indirizzo esistente"
    },
    "pay_stripe": "Conferma e paga",
    "terms": "Confermando la tua iscrizione, consenti a Linguise di addebitarti pagamenti futuri in conformità con i nostri termini. Puoi sempre annullare il tuo abbonamento.",
    "coupon": {
      "title": "Hai un buono?",
      "placeholder": "Inserisci qui il tuo codice coupon",
      "apply": "Fare domanda a",
      "percent": "{{0}}% di sconto"
    },
    "add_new": "Aggiungi nuovo",
    "use_existing": "Utilizza il metodo di pagamento esistente",
    "recurring": {
      "month_single": "Fatturazione mensile",
      "month_many": "Fatturazione ogni {{count}} mesi",
      "year_single": "Fatturato annualmente",
      "year_many": "Fatturazione ogni {{count}} anni",
      "day_single": "Fatturato giornalmente",
      "day_many": "Fatturazione ogni {{count}} giorni",
      "week_single": "Fatturazione settimanale",
      "week_many": "Fatturazione ogni {{count}} settimane"
    },
    "add_new_no_stripe": "Aggiungi nuova carta",
    "summary": {
      "title": "Riepilogo",
      "subtotal": "Totale parziale",
      "total": "Totale"
    }
  },
  "dashboard": {
    "main": {
      "title": "Pannello"
    },
    "statistics": {
      "main_title": "Statistiche degli ultimi 30 giorni",
      "characters": "Caratteri tradotti",
      "words": "Parole tradotte",
      "bandwidth": "Larghezza di banda in ingresso",
      "request": "Richieste",
      "page_views": "Pagine viste per lingua (ultimi 30 giorni)",
      "multilingual_views": "Visualizzazioni di pagine multilingue (ultimi 30 giorni)",
      "most_page_viewed": "20 Pagine più viste (ultimi 30 giorni)",
      "no_data_yet": "Nessun dato ancora disponibile",
      "th_language": "Lingua",
      "th_page_views": "Visualizzazioni pagina",
      "real_visitors": "Visitatori reali",
      "crawler": "Crawler web"
    },
    "planHints": {
      "subscribeButton": "Iscriviti",
      "upgradeButton": "Aggiornamento",
      "usedWords": "Attualmente sei {words_used} parole",
      "noPlan": "Nessun piano attivato per questo dominio. Iscriviti ad piano e inizia a tradurre il tuo sito web",
      "trialUsage": "Attualmente stai usando{words_used} parole delle {words_allowed} parole incluse nel piano di prova.",
      "trialEnds": "Il 1° mese di prova è attivato fino a {trial_ends}.",
      "subscribeMessage": "Iscriviti prima che finisca per mantenere il tuo sito web tradotto",
      "trialReachedLimit": "Hai raggiunto il massimo di parole tradotte per il periodo di prova.\nIscriviti ad uno dei nostri piani per continuare a tradurre il tuo sito web",
      "paidUsage": "Hai utilizzato {words_used} / {words_allowed} parole tradotte nel tuo piano.",
      "paidReachedLimit": "Hai raggiunto il massimo di parole tradotte per il piano attuale.\nAggiorna il tuo piano per continuare a tradurre il contenuto del tuo sito web",
      "trialOfferedUsage": "Stai attualmente utilizzando {words_used} parole delle {words_allowed} parole incluse nel piano di prova.(Incluse le {free_words} parole offerte)",
      "paidOfferedUsage": "Hai utilizzato {words_used} / {words_allowed} parole tradotte nel tuo piano.(Incluse le {free_words} parole offerte)",
      "noPlanExtra": "Tieni presente che i domini inattivi e i relativi dati vengono automaticamente eliminati regolarmente.",
      "planRecommended": "In base al tuo attuale volume di traduzioni, il piano consigliato è:",
      "planMaximumWords": "{{words}} parole",
      "notHaveTranslatedWords": "Non hai ancora effettuato alcuna traduzione",
      "noPlanShopify": "Nessun piano attivato per questo dominio. Abbonati a un piano nella dashboard di Shopify e inizia a tradurre il tuo sito web.",
      "subscribeMessageShopify": "Iscriviti dalla dashboard di Shopify prima che finisca per mantenere il tuo sito web tradotto"
    },
    "translationSetup": {
      "kicker": "CONFIGURAZIONE DEL SOTTODOMINIO",
      "title": "Verifica la configurazione della traduzione",
      "description": "Controlla DNS, host tradotti, accesso al sito originale e limiti dell’account.",
      "starting": "Verifica in corso...",
      "button": "Verifica configurazione",
      "viewLatest": "Visualizza l’ultimo risultato",
      "viewCurrent": "Visualizza il controllo attuale",
      "runAgain": "Esegui di nuovo il controllo",
      "viewDetails": "Visualizza dettagli",
      "hideDetails": "Nascondi dettagli",
      "error": "Impossibile verificare la configurazione",
      "allPassed": "Tutti i controlli sono superati",
      "setupNeedsAttention": "La configurazione richiede attenzione",
      "setupNeedsAttentionDescription": "Uno o più controlli non sono riusciti. Esamina gli elementi qui sotto o contatta l’assistenza Linguise.",
      "lastChecked": "Ultimo controllo: {{time}}",
      "domainOwnership": "Proprietà del dominio",
      "domainOwnershipDescription": "Record di verifica trovato",
      "domainOwnershipFailure": "Impossibile verificare il record DNS di proprietà.",
      "translatedHosts": "Host tradotti",
      "translatedHostsDescription": "Controllati {{count}} host linguistici",
      "translatedHostsFailure": "Uno o più record CNAME linguistici non sono corretti.",
      "subdomainPage": "Pagina del sottodominio",
      "subdomainPageDescription": "{{count}} pagine tradotte accettano HTTPS",
      "subdomainPageFailure": "Connessione TLS non riuscita durante l’apertura di una o più pagine tradotte.",
      "originalSite": "Sito originale",
      "originalSiteDescription": "Controlli DNS, TLS e risposta del sito originale",
      "originalSiteFailure": "Controllo DNS, TLS o della risposta del sito originale non riuscito.",
      "documentationAdvice": {
        "dns": "Verifica configurazione DNS",
        "tls": "Verifica configurazione HTTPS",
        "origin": "Verifica configurazione del sito originale",
        "diagnostic": "Consulta i passaggi per la risoluzione dei problemi"
      },
      "evidence": {
        "originDns": "DNS originale",
        "originTls": "TLS originale",
        "originHttp": "Risposta originale",
        "observedTargets": "Destinazioni rilevate",
        "recordCount": "Record trovati",
        "addressCount": "Indirizzi trovati",
        "statusCode": "Stato HTTP",
        "redirect": "Reindirizzamento",
        "expiresAt": "Scadenza del certificato",
        "raw": "{{key}}",
        "noValue": "Nessun valore"
      },
      "checkerError": "Impossibile completare alcuni controlli.",
      "coreLocation": "Controllato da {{location}}",
      "status": {
        "queued": "In coda",
        "running": "In esecuzione",
        "completed": "Completato",
        "failed": "Non riuscito",
        "passed": "Superato",
        "warning": "Avviso",
        "unknown": "Sconosciuto",
        "skipped": "Ignorato",
        "not_applicable": "Non applicabile"
      }
    },
    "throttling": {
      "title": "Limite di traduzione",
      "description": "Limiti di utilizzo temporanei",
      "unavailable": "Limiti temporanei di traduzione non disponibili",
      "window": "{{used}} / {{max}} parole",
      "resetsIn": "Si reimposta tra {{time}}",
      "throttled": "Traduzione sospesa temporaneamente",
      "throttledDescription": "È stato raggiunto un limite temporaneo di utilizzo. La traduzione riprenderà al ripristino di questo intervallo."
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "PASSAGGIO {{step}} DI {{total}}",
      "doneLabel": "FATTO, PUOI INIZIARE A TRADURRE!",
      "finish": {
        "title": "",
        "description": "Questa è la chiave API da utilizzare sul tuo sito web"
      },
      "instructions": "Istruzioni per l'installazione",
      "domainSetting": "Impostazione del dominio",
      "step": {
        "titleWordpress": "Wordpress",
        "titleJoomla": "Joomla",
        "titlePHP": "Script PHP",
        "wizardWordpressStep1": "1. Installare il ",
        "wizardWordpressStep2": "\n 2. Nelle impostazioni del plugin copia e compila la tua chiave API\n",
        "wizardWordpressStep3": "3. Sei pronto a tradurre\n\n",
        "wizardWordpressStep4": "Per un'istruzione più dettagliata, date un'occhiata alla nostra documentazione: ",
        "wizardJoomlaStep1": "1. Collegamento al pacchetto Joomla: ",
        "wizardJoomlaStep2": "\n2. Nelle impostazioni di configurazione dell'estensione copia e inserisci la tua chiave API",
        "wizardJoomlaStep4": "\n 4. Sei pronto a tradurre\n\n",
        "wizardJoomlaStep3": "3. Nella configurazione del modulo, imposta le lingue che vuoi visualizzare e inserisci il tuo modulo dove ti serve.",
        "wizardPhpStep1": "1. Scarica il nostro script php e qui ",
        "wizardPhpStep2": "\n2. Segui le istruzioni di installazione nella nostra pagina di documentazione qui ",
        "wizardPhpStep3": "\n3. Aggiungete il modulo alle vostre pagine.",
        "wizardPhpStep4": "\n Copia il seguente codice e aggiungilo alla testa della tua pagina html, visualizzerà automaticamente il modulo di commutazione\n",
        "dispatchStep1": "Abbiamo inviato correttamente i dati richiesti al plugin Linguise. Ora puoi chiudere la finestra seguente.",
        "dispatchStep2": "Nel caso in cui il token risultasse mancante quando chiudi questa finestra, copia il seguente token:",
        "dispatchStep3": "Puoi anche copiare questo frammento per abilitare automaticamente il nostro cambio di flag",
        "wizardOtherStep1": "Segui le istruzioni riportate di seguito per installare Linguise sul tuo dominio.",
        "wizardOtherStep2": "Copia il seguente codice e aggiungilo all'intestazione della tua pagina HTML: verrà visualizzato automaticamente il modulo switcher."
      },
      "trialAlreadyUsed": "Sembra che tu abbia già usato la tua prova gratuita, quindi hai bisogno di ottenere la quota di traduzione\nSottoscrivi un piano o contattaci se hai bisogno di estendere la tua prova.",
      "usefulLinks": "Link utili per iniziare",
      "linkDocumentation": "Documentazione",
      "linkExtensionDl": "Estensione download",
      "linkSubscribe": "Iscriviti ad un piano adesso",
      "linkDashboard": "Vai alla pannello",
      "exclusion": {
        "title": "Nomi azienda e prodotti",
        "description": ""
      },
      "finishButton": "Finisci la configurazione",
      "subdomains": "Sottodomini",
      "subdomain_setup": "Configura dominio",
      "subdomain_auto_setup": "Connetti automaticamente il tuo DNS",
      "subdomain_manual_setup": "Aggiungo personalmente le voci DNS",
      "subdomain_skip": "Aggiungo personalmente le voci DNS",
      "auto_subdomains_info": "Il CMS del tuo site builder richiede una configurazione DNS per impostare le lingue per sottodominio (es. it.domain.com). Puoi farlo automaticamente utilizzando Entri. Basta fare clic sul pulsante \"Connetti i tuoi DNS automaticamente\" per iniziare a connetterti al tuo gestore DNS e aggiungerli con Entri. ",
      "auto_subdomains_info_manual": "In alternativa, puoi configurare manualmente il tuo dominio facendo clic sul pulsante \"Aggiungi voci DNS personalmente\".",
      "auto_subdomains_info_2": "Puoi farlo automaticamente utilizzando Entri. Basta fare clic sul pulsante \"Connetti i tuoi DNS automaticamente\" per iniziare a connetterti al tuo gestore DNS e aggiungerli con Entri. ",
      "breadcrumbs": {
        "step1": "Fase 1: Dominio, CMS e lingue",
        "step2": "Passaggio 2: DNS della lingua",
        "step3": "Fase {{step}}: Istruzioni per l'installazione"
      }
    },
    "form": {
      "urls": {
        "dash": "Trattino -",
        "underscore": "Sottolineare _",
        "title": "Traduci URL",
        "description": "Vuoi tradurre tutte le pagine",
        "char_description": "Caratteri da usare per sostituire caratteri non autorizzati negli URL",
        "advertisement_title": "⚠ Hai impostato molte lingue.\n",
        "advertisement": "Di solito consigliamo di iniziare a tradurre siti web con poche lingue all'inizio. Avrai un'idea di quante parole ha il tuo sito web. \nÈ anche meglio per il SEO, perché i bot di Google scansioneranno più velocemente tutte le tue pagine se hai meno pagine all'inizio.\nDopo una settimana puoi aggiungere qualche altra lingua e così via."
      },
      "url": {
        "title": "Url",
        "description": "Inserisci l'URL del tuo dominio principale che inizia con http:// o https://",
        "placeholder": "Dominio URL",
        "advertisement_http": {
          "title": "Non stai usando il protocollo https",
          "description": "Si prega di verificare che il proprio dominio non utilizzi effettivamente il protocollo https, attualmente consigliato."
        },
        "advertisement_www": {
          "title": "Il tuo sottodominio non è www",
          "description": "La maggior parte delle volte il sottodominio predefinito è www (come https://www.miodominio.com). Questo potrebbe non essere il tuo caso, ma ricontrolla che il dominio che desideri aggiungere sia quello corretto."
        },
        "invalid_url": {
          "line1": "Non siamo riusciti a trovare il tuo dominio. Verifica che il tuo dominio sia accessibile pubblicamente tramite Internet e non sia reindirizzato a un'altra posizione. ",
          "line2": "Se sei sicuro che il tuo dominio sia accessibile, puoi saltare la verifica del dominio e premere nuovamente il pulsante \"Passaggio successivo\".",
          "contact": "In ogni caso potete contattarci all'indirizzo",
          "force": "Salta la verifica del dominio"
        },
        "invalid_subdomain_url": "Questo URL non è consentito. I sottodomini devono essere nel formato: https://www.dominio.tld o https://dominio.tld senza sottodirectory."
      },
      "account": {
        "title": "Account",
        "description": "Seleziona un account per assegnare questo dominio",
        "placeholder": "Seleziona account...",
        "feedback": "Devi scegliere un account"
      },
      "platform": {
        "title": "Piattaforma",
        "description": "Seleziona la piattaforma del tuo sito web in base al nome CMS.",
        "learn": "Scopri come sceglierlo",
        "placeholder": "Cerca piattaforma per nome CMS...",
        "info": {
          "title": "⚠ Questa piattaforma è stata aggiunta di recente.\n",
          "desc": "Questa piattaforma per la creazione di siti Web è supportata da Linguise, sebbene sia stata aggiunta di recente. In caso di problemi, contattaci utilizzando l'e-mail di supporto diretto:"
        },
        "description_read_only": "La piattaforma utilizzata dal tuo sito web",
        "feedback": "Devi scegliere una piattaforma"
      },
      "language": {
        "title": "Lingua",
        "description": "Seleziona la lingua di base del tuo sito web",
        "placeholder": "Seleziona la lingua...",
        "feedback": "Devi scegliere una lingua",
        "description_read_only": "Lingua base del tuo sito web"
      },
      "token": {
        "title": "Chiave API",
        "description": "Questa è la chiave API da copiare sul tuo sito web",
        "copy": "Copia negli appunti",
        "reset": "Reimposta chiave API",
        "reset_confirm": "Conferma il reset del API Key"
      },
      "languages": {
        "title": "Lingue per la traduzione",
        "description": "Seleziona le lingue in cui vuoi che il tuo sito web sia traducibile",
        "placeholder": "Seleziona lingue...",
        "feedback": "Devi scegliere una lingua"
      },
      "defaultRules": {
        "title": "Regole predefinite",
        "description": "Abbiamo definito una serie di regole da utilizzare per migliorare la traduzione ed evitare la traduzione di contenuti indesiderati, come la pannello di WordPress.\nPuoi rimuovere o modificare queste regole in un secondo momento, se lo desideri."
      },
      "disallow_deletion": "Non puoi cancellare il dominio con un abbonamento attivo",
      "delete_confirm": "Conferma la cancellazione del dominio",
      "delete": "Cancella dominio",
      "dynamic": {
        "title": "Traduci contenuti dinamici",
        "description": "Il contenuto dinamico generato dalla richiesta JavaScript e AJAX verrà tradotto (questa opzione aumenterà l'utilizzo della traduzione)"
      },
      "partial_translations": {
        "title": "Consenti traduzione parziale",
        "description": "Se il tuo account ha raggiunto la quota di traduzione ma la pagina necessita ancora di traduzione, Linguise può continuare a visualizzare la pagina con il contenuto che è già stato tradotto. Tuttavia, alcune parti della pagina rimarranno non tradotte finché non aggiornerai la tua quota. Sebbene una piccola quantità di contenuti non tradotti di solito non danneggi la SEO, consentire troppi contenuti non tradotti potrebbe avere un impatto negativo sull'esperienza dell'utente. Per risolvere questo problema, puoi impostare una soglia per la percentuale di contenuto non tradotto consentito su una pagina. Se il contenuto non tradotto supera questa soglia, gli utenti verranno automaticamente reindirizzati alla versione in lingua originale della pagina.",
        "never": "Mai"
      },
      "translate_error_pages": {
        "title": "Traduci le pagine di errore",
        "description": "Linguise può tradurre tutte le pagine di errore, tuttavia se la tua pagina di errore contiene contenuto dinamico, come indirizzo IP o ID richiesta, dovresti evitare di tradurre queste pagine.",
        "not_found_page": {
          "title": "Traduci la pagina 404"
        },
        "error_page": {
          "title": "Traduci altre pagine di errore"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "Dominio esistente trovato",
          "description": "È stato trovato un dominio esistente per questo utente. Vuoi utilizzarlo?"
        }
      },
      "search_tl": {
        "title": "Cerca traduzioni",
        "description": "Abilita le traduzioni di ricerca per la piattaforma del tuo sito web (sperimentale, questa opzione aumenterà l'utilizzo delle traduzioni)"
      },
      "shopify_promo": {
        "info": "Buone notizie! Ora abbiamo un'app nativa di Shopify che puoi installare dall'App Store di Shopify.",
        "hyperlink": "Clicca qui ed esegui l'installazione di Linguise dall'app.",
        "next_btn": "Vai allo store Shopify per installare l'app",
        "info_legacy": "Buone notizie! Ora abbiamo un'app nativa di Shopify che puoi installare dall'App Store di Shopify.",
        "description_legacy": "Seleziona la piattaforma \"Shopify\" invece di \"Shopify Legacy\""
      },
      "wix_promo": {
        "info": "Buone notizie! Ora abbiamo un'app nativa di Wix che puoi installare dal Wix App Market.",
        "hyperlink": "Clicca qui ed esegui l'installazione di Linguise dall'app.",
        "next_btn": "Vai al Wix App Market per installare l'app",
        "info_legacy": "Buone notizie! Ora abbiamo un'app nativa di Wix che puoi installare dal Wix App Market.",
        "description_legacy": "Seleziona la piattaforma \"Wix\" invece di \"Wix Legacy\""
      },
      "ai_disallow_deletion": "Non puoi eliminare questo dominio finché è ancora disponibile una quota AI. Contatta il nostro team di supporto se desideri eliminare questo dominio all'indirizzo",
      "language_removal": {
        "card": {
          "title": "Elimina le traduzioni delle lingue rimosse",
          "description": "Queste lingue sono state rimosse dal tuo sito, ma le traduzioni salvate continuano a essere conteggiate nella quota. Eliminale per recuperare le parole.",
          "button": "Elimina traduzioni"
        },
        "hint": "Le parole utilizzate verranno restituite alla tua quota. Puoi farlo una volta ogni {{days}} giorni per ogni sito.",
        "modal": {
          "title": "Eliminare le traduzioni?",
          "intro": "Queste traduzioni verranno eliminate definitivamente:",
          "warning": "Questa azione non può essere annullata. Le parole utilizzate verranno restituite alla tua quota; l'operazione può richiedere alcuni minuti.",
          "limit": "Puoi farlo una volta ogni {{days}} giorni per ogni sito.",
          "confirm": "Elimina traduzioni"
        },
        "scheduled": "Le traduzioni sono in fase di eliminazione e la quota verrà aggiornata a breve.",
        "cooldown": "Le traduzioni di questo sito sono state eliminate di recente. Potrai eliminarle di nuovo il {{date}}.",
        "latest_completed": {
          "title": "Ultima eliminazione completata",
          "description": "Controlla le lingue eliminate e le parole restituite alla tua quota.",
          "languages": "Lingue eliminate",
          "words_returned": "Parole restituite alla tua quota: {{words}}",
          "completed_at": "Completato il {{date}}"
        },
        "status": {
          "recent_title": "Eliminazione recente delle traduzioni",
          "recent_description": "Segui l'ultima eliminazione e scopri quando sarà disponibile la successiva.",
          "progress_title": "Avanzamento dell'eliminazione",
          "loading": "Verifica dell'avanzamento dell'eliminazione...",
          "unavailable": "Impossibile caricare l'avanzamento dell'eliminazione. Aggiorna la pagina e riprova.",
          "label": "Stato",
          "pending": "In coda",
          "processing": "In corso",
          "completed": "Completato",
          "failed": "Non riuscito",
          "unknown": "Stato non disponibile",
          "percent": "{{percent}}% completato",
          "current_stage": "Fase attuale: {{stage}}",
          "processed": "{{processed}} record elaborati",
          "processed_total": "{{processed}} record su {{total}} elaborati",
          "requested_at": "Richiesto il {{date}}",
          "started_at": "Avviato il {{date}}",
          "completed_at": "Completato il {{date}}",
          "cooldown_period": "Puoi farlo una volta ogni {{days}} giorni per ogni sito.",
          "cooldown_blocked": "Non è ancora possibile avviare un'altra eliminazione.",
          "stage": {
            "queued": "In attesa di avvio",
            "processing": "In corso",
            "refund_summary": "Calcolo delle parole restituite",
            "search_translations": "Eliminazione delle traduzioni di ricerca",
            "url_translations": "Eliminazione delle traduzioni URL",
            "translations": "Eliminazione delle traduzioni",
            "completed": "Completato",
            "failed": "Non riuscito",
            "unknown": "In corso"
          }
        },
        "forbidden": "Non hai l'autorizzazione per eliminare le traduzioni."
      }
    },
    "main": {
      "edit": "Modifica dominio",
      "add": "Aggiungi dominio",
      "wizard": "Benvenuto! Procedura guidata per la creazione di un nuovo dominio",
      "common": "Dominio"
    },
    "subdomains": {
      "config_ok": "Il DNS dei sottodomini è stato configurato correttamente.",
      "config_invalid": "Il DNS dei sottodomini richiede alcune configurazioni aggiuntive per funzionare.",
      "config_check": "È in corso il controllo della configurazione DNS dei sottodomini, attendere prego...",
      "entri_timeout": "Entri ha segnalato che il processo di propagazione DNS dei sottodomini è scaduto, dovresti riprovare oppure puoi farlo manualmente.",
      "entri_process": "I tuoi DNS sono stati aggiunti con Entri e di solito ci vogliono 10-30 minuti per propagarsi (applica tutti i sottodomini delle tue lingue come it.domain.com). Se la convalida DNS non viene completata dopo 24 ore, puoi contattare il nostro team di supporto: support@linguise.com ",
      "entri_ok": "La propagazione DNS è in arrivo! In attesa della propagazione... ",
      "infos": "È necessario aggiungere queste voci DNS ai record del dominio DNS per attivare la traduzione. Fare clic sul pulsante di controllo al termine dell'operazione. È possibile che la propagazione dei record DNS richieda del tempo, quindi potrebbe essere necessario tornare dopo alcuni minuti o ore.",
      "check": "Controlla la configurazione DNS"
    },
    "notice": {
      "broken_card": "Non siamo riusciti a rinnovare il tuo piano per {{url}} utilizzando il metodo di pagamento attuale, aggiorna la tua carta di pagamento",
      "quota_reached": "La tua quota di traduzione per {{url}} è stata raggiunta, esegui l'upgrade per riprendere la traduzione del tuo sito web",
      "important": "Importante",
      "quota_reached_button": "Aggiorna il tuo piano ora",
      "broken_card_button": "Aggiorna la tua carta di pagamento",
      "ai_no_subscription": "La traduzione AI per {{url}} richiede un abbonamento attivo o una prova attiva. In caso contrario, la traduzione si interromperà. Aggiorna per continuare.",
      "ai_no_subscription_button": "Aggiorna subito il tuo piano",
      "quota_warning": "La tua quota di traduzione per {{url}} ha raggiunto il {{throttling_used_percent}}%, questo verrà reimpostato tra {{ttl}}",
      "locked": "Il dominio {{url}} è attualmente bloccato per la migrazione, puoi ancora accedere al tuo sito ma non puoi modificare o aggiungere nuove traduzioni!"
    },
    "subscription": {
      "next_payment_amount": "Prossime accuse",
      "next_payment_date": "Prossima data di pagamento",
      "invoice": {
        "header": "Storico fatture",
        "date": "Data",
        "amount_due": "Quantità",
        "status": "Stato",
        "actions": "Azioni",
        "description": "Una volta che le transazioni sono disponibili, puoi visualizzarle qui.",
        "status_text": {
          "draft": "Bozza",
          "open": "In attesa di",
          "paid": "Pagato",
          "uncollectible": "Incollezionabile",
          "void": "Vuoto",
          "failed": "Fallito",
          "retrying": "Riprovare"
        },
        "view": "Visualizzazione",
        "empty": "Non ci sono fatture recenti trovate per questo abbonamento",
        "retry_payment": "Riprova"
      },
      "next_cancellation": "Data di cancellazione",
      "cancel": "Annulla l'abbonamento",
      "change_plan": "Cambia piano",
      "change": "Modifica",
      "suspend": "Sospendere il pagamento",
      "resume": "Riprendere l'abbonamento",
      "back": "Indietro",
      "save": "Salva",
      "confirm_resume": "Sei sicuro di voler ripristinare questo abbonamento?",
      "confirm_cancel": "Sei sicuro di voler annullare questo abbonamento?",
      "confirm_header": "Sei sicuro?",
      "missing_status": "Questo abbonamento manca",
      "not_found": "Nessun abbonamento trovato per questo dominio",
      "no_payment_method": "Sconosciuto",
      "remove_billing": "Rimuovere",
      "confirm_manual_retry": "Sei sicuro di voler riprovare questo pagamento?",
      "shopify_maneged": "Questo abbonamento è gestito da Shopify. Puoi gestirlo dal pannello di amministrazione di Shopify.",
      "unknown_plan": "Piano sconosciuto"
    }
  },
  "domain_listing": {
    "select": "Seleziona un dominio",
    "add": "Aggiungi sito web"
  },
  "editable": {
    "number": "numero {{id}}"
  },
  "footer": {
    "about": "Su di noi",
    "support": "Supporto"
  },
  "frontendEditor": {
    "main": "Editor live",
    "description": "Il Live Editor ti aiuta a modificare direttamente le traduzioni nel tuo sito web.",
    "button": "Apri Live Editor",
    "language_selection": "Selezione della lingua di traduzione",
    "video_label": "Scopri come utilizzare l'editor live"
  },
  "general": {
    "403": {
      "tab_title": "Ooops – Errore 403",
      "title": "Accesso negato",
      "message": "Sembra che tu non abbia accesso alla pagina richiesta.",
      "home": "Torna a casa"
    },
    "404": {
      "tab_title": "Ooops – Errore 404",
      "title": "Pagina Non Trovata",
      "message": "Sembra che tu abbia sbagliato strada. Non preoccuparti, succede anche ai migliori di noi. Ecco un piccolo suggerimento che potrebbe aiutarti a tornare in pista.",
      "home": "Torna alla Home"
    },
    "500": {
      "tab_title": "Error 500",
      "title": "Errore interno del server",
      "message": "Perché non provi ad aggiornare la tua pagina? oppure contattaci",
      "home": "Torna alla Home"
    },
    "fields": {
      "alert": "Alcuni campi non sono validi, per favore correggi i campi non validi.",
      "invalid": "Questo campo non è valido",
      "phone_re": "Il numero di telefono non è valido",
      "phone_invalid": "Il numero di telefono non è valido",
      "email": "Il campo email non è valido"
    },
    "saving": "Salvataggio ...",
    "save": "Salva",
    "save_and_quit": "Salva ed esci",
    "invite": "Invitare",
    "cancel": "Cancella",
    "yes": "Si",
    "no": "No",
    "nextStep": "Prossimo passaggio",
    "loading": "Attendi che l'applicazione venga caricata",
    "goback": "Torna indietro",
    "manage": "Gestisci",
    "delete": "Cancella",
    "deleting": "Cancellando ...",
    "table": {
      "no_data": "Non ci sono ancora dati qui..."
    },
    "confirm": "Confermare",
    "unknown": "Sconosciuto",
    "hide": "Nascondere",
    "show": "Spettacolo",
    "on": "SU",
    "off": "Spento",
    "default": "Predefinito"
  },
  "home": {
    "header": "Casa",
    "manage": "Gestisci abbonamento",
    "activate_now": "Attivare ora",
    "activate_plan_now": "Iscriviti ora",
    "upgrade_plan_now": "Aggiorna il piano adesso",
    "trial_message_part_1": "Attualmente utilizzi il piano di prova, ",
    "trial_message_part_2": "puoi attivare un abbonamento in qualsiasi momento.",
    "add": "Aggiungi dominio",
    "table": {
      "title": "Domini",
      "description": "Elenco dei tuoi domini, clicca sul dominio per gestire le traduzioni"
    },
    "domains": {
      "empty": "Non hai alcun dominio in questo account"
    },
    "accountsList": {
      "title": "Conti",
      "add": "Aggiungi un nuovo account",
      "name": "Nome utente"
    },
    "update_credit_card": "Aggiorna i dettagli della carta di credito",
    "canceled": "Abbonamento annullato",
    "cancelling_subs": "Annullamento alle {{0}}",
    "resume_subscription": "Riprendere l'abbonamento",
    "shopify_managed": "Gestito da Shopify",
    "trial_ends_at": "Termina alle {{0}}",
    "free_trial": "Prova gratuita",
    "no_subs": "Nessun abbonamento attivo"
  },
  "invoices": {
    "title": "Fatture",
    "list": {
      "title": "Lista fatture"
    },
    "table": {
      "customer": "Clienti",
      "domain": "Dominio",
      "amountPaid": "Importo pagato",
      "status": "Stato",
      "date": "Data",
      "invoice": "Fattura",
      "pay": "Pagare la fattura",
      "actions": "Azioni",
      "deleted_domain": "Dominio eliminato",
      "plan_name": "Piano",
      "action": "Azione"
    },
    "listPending": {
      "title": "Elenco fatture in sospeso"
    }
  },
  "language_settings": {
    "display": "Visualizzazione dell'elenco delle lingue",
    "position": "Posizione",
    "display_help_text": "Mostra i nomi delle bandiere e/o delle lingue. La posizione predefinita del selettore di lingua potrebbe essere ovunque nel contenuto o in una posizione fissa che rimane fissa o si sposta sullo scorrimento",
    "side_by_side": "Fianco a fianco",
    "dropdown": "Cadere in picchiata",
    "popup": "Apparire",
    "flag": "Bandiera",
    "lang_name": "Nome della lingua",
    "lang_short_name": "Nomi brevi",
    "positions": {
      "in_place": "A posto",
      "top_left": "A sinistra in alto",
      "top_left_no_scroll": "In alto a sinistra (senza scorrimento)",
      "top_right": "In alto a destra",
      "top_right_no_scroll": "In alto a destra (senza scorrimento)",
      "bottom_left": "In basso a sinistra",
      "bottom_left_no_scroll": "In basso a sinistra (senza scorrimento)",
      "bottom_right": "In basso a destra",
      "bottom_right_no_scroll": "In basso a destra (senza scorrimento)"
    },
    "lang_names_display": {
      "title": "Vengono visualizzati i nomi delle lingue",
      "help_text": "Nel selettore di lingua, visualizza i nomi delle lingue in inglese o nella lingua originale, ad esempio francese o francese",
      "english": "Inglese",
      "native_languages": "Lingue madri"
    },
    "flag_shape": {
      "title": "Stile bandiera",
      "help_text": "Utilizzare icone di bandiera svg rotonde o rettangolari",
      "round": "Girare",
      "rectangular": "Rettangolare"
    },
    "english_flag_type": {
      "title": "Tipo di bandiera inglese",
      "help_text": "Usa la bandiera della Gran Bretagna o degli Stati Uniti per l'inglese",
      "usa": "Bandiera degli Stati Uniti",
      "great_britain": "Bandiera della Gran Bretagna"
    },
    "german_flag_type": {
      "title": "Tipo di bandiera tedesca",
      "help_text": "Usa la bandiera austriaca o tedesca per il tedesco",
      "german": "Bandiera tedesca",
      "austria": "Bandiera dell'Austria"
    },
    "spain_flag_type": {
      "title": "Tipo di bandiera spagnola",
      "help_text": "Usa la bandiera del Messico o della Spagna per lo spagnolo",
      "spanish": "Bandiera spagnola",
      "mexico": "Bandiera del Messico",
      "peruvian": "Bandiera Peruviana"
    },
    "portugal_flag_type": {
      "title": "Tipo di bandiera portoghese",
      "help_text": "Usa la bandiera portoghese o brasiliana per il portoghese",
      "portugal": "Bandiera portoghese",
      "brazil": "Bandiera brasiliana"
    },
    "taiwanese_flag_type": {
      "title": "Tipo di bandiera taiwanese",
      "help_text": "Utilizza la bandiera taiwanese o cinese per il taiwanese",
      "taiwanese": "Bandiera taiwanese",
      "chinese": "Bandiera cinese"
    },
    "flag_border_radius": {
      "title": "Raggio bordo bandiera (px)",
      "help_text": "Se stai utilizzando la forma della bandiera rettangolare, puoi applicare un raggio del bordo personalizzato in pixel"
    },
    "flag_width": {
      "title": "Dimensione bandiera (px)",
      "help_text": "Seleziona la dimensione dei flag in pixel. Ciò non cambia il peso dell'immagine in quanto è un formato .svg"
    },
    "lang_color": {
      "color_title": "Colore del nome della lingua",
      "color_help_text": "Seleziona un colore di testo predefinito per i nomi delle lingue",
      "hover_color_title": "Colore al passaggio del mouse del nome della lingua",
      "hover_color_help_text": "Seleziona un colore del testo al passaggio del mouse per i nomi delle lingue",
      "color_popup_title": "Colore della lingua popup",
      "color_popup_help_text": "Colore del titolo della lingua nel popup o nelle aree a discesa",
      "hover_color_popup_title": "Colore al passaggio del mouse della lingua popup",
      "hover_color_popup_help_text": "Selezionare un colore del testo al passaggio del mouse del titolo della lingua nel popup o nelle aree a discesa"
    },
    "flag_box_shadow": {
      "shadow_title": "Ombra della casella di bandiera",
      "shadow_help_text": "Colore e dimensione dell'ombra per le bandiere della tua lingua",
      "hover_shadow_title": "Flag box ombra al passaggio del mouse",
      "hover_shadow_help_text": "Colore e dimensione dell'ombra per le bandiere della tua lingua al passaggio del mouse",
      "shadow_h_offset": "Offset H ombra (px)",
      "shadow_v_offset": "Offset ombra V (px)",
      "shadow_blur": "Sfocatura dell'ombra (px)",
      "shadow_spread": "Diffusione dell'ombra (px)",
      "shadow_color": "Colore dell'ombra"
    },
    "order": "Ordine linguistico",
    "language_order_help": "L'ordine della lingua che verrà visualizzata nel commutatore di lingua. Puoi trascinare e rilasciare la lingua per riordinarli. ",
    "order_reset": "Ripristina l'ordine",
    "language_order_dragdrop": "Puoi trascinare e rilasciare la lingua per riordinarli.",
    "popup_lang_name": "Nome della lingua del popup",
    "preview": "Anteprima della lingua"
  },
  "link": {
    "form": {
      "original": {
        "title": "Fonte originale",
        "description": "Aggiungi l'URL del link originale e sostituiscilo di seguito con la lingua per tradurli",
        "srcset_description": "Stai modificando l'URL di un'immagine. Assicurati di leggere la documentazione, soprattutto se usi srcset o non sai di cosa si tratta",
        "link": "Collegamento",
        "match_link": "Modalità partita",
        "match_exact": "Esatto",
        "match_wildcard": "Carattere jolly",
        "match_regex": "Espressione regolare"
      },
      "alternative_languages": {
        "title": "Collegamenti da sostituire",
        "description": "Sostituisci i collegamenti multimediali e i collegamenti esterni in tutte le tue pagine, in base alla lingua...",
        "link": "Collegamento da sostituire"
      },
      "error": {
        "atLeastOne": "Per favore aggiungi almeno una traduzione.",
        "url": "L'URL non è valido",
        "extension": "Il collegamento dovrebbe avere un'estensione, ma non può essere .html o .php. E il collegamento non deve contenere alcun percorso linguistico, ad es. \"/fr\"",
        "regex": "L'espressione regolare non è valida",
        "wildcard": "Il collegamento jolly ha un protocollo non valido"
      }
    },
    "main": {
      "parent": "Collegamenti",
      "edit": "Modifica collegamento"
    }
  },
  "links": {
    "title": "Gestione media e link esterni",
    "description": "Elenca e modifica il tuo sito Web Collegamenti multimediali o collegamenti esterni.",
    "add": "Aggiungi collegamento",
    "delete": "Elimina collegamento",
    "table": {
      "original": "Originale",
      "language": "Lingua",
      "translation": "Traduzione",
      "action": "Azione",
      "delete_confirm": "Si prega di confermare l'eliminazione del collegamento"
    }
  },
  "members": {
    "header": "Membri",
    "invite": "Invita un nuovo membro",
    "modal": {
      "inviteHeader": "Invita un nuovo membro",
      "editHeader": "Modifica membro",
      "detachHeader": "Staccare membro",
      "detachBody": "Sei sicuro di voler scollegare il membro da questo account?",
      "selfDetachBody": "Sei sicuro di volerti staccare da questa gestione dell'account? Successivamente, non potrai accedere a nessuno dei dati relativi a questo account. "
    },
    "table": {
      "title": "Elenco dei membri",
      "description": "Ruoli dei membri e accesso ai domini",
      "name": "Nome",
      "email": "Email",
      "websites": "Siti web",
      "languages": "Le lingue",
      "role": "Ruolo",
      "status": "Stato",
      "resendInvite": "inviare nuovamente",
      "inviteSent": "l'invito è stato inviato",
      "actions": "Azioni",
      "edit": "Modificare",
      "detach": "Stacca",
      "empty": "Non hai ancora nessun membro",
      "all_website": "Tutti i siti web e le lingue",
      "roles": {
        "admin": "Amministratore",
        "manager": "Manager",
        "translator": "Traduttore"
      },
      "statuses": {
        "pending": "In attesa",
        "accepted": "Accettato",
        "declined": "Rifiutato"
      }
    },
    "errors": {
      "role": "Devi scegliere un ruolo",
      "domains": "Devi scegliere almeno 1 sito web per il ruolo selezionato",
      "languages": "Devi scegliere almeno 1 lingua per i siti web selezionati"
    },
    "inviteSent": "Il tuo invito è stato inviato con successo"
  },
  "pagination": {
    "showing": "Mostra {{limit}} di {{total}} risultati",
    "showing_only_count": "Mostra {{limit}} risultati"
  },
  "payments_method": {
    "header": "Metodi di pagamento",
    "table": {
      "title": "Elenco metodi di pagamento",
      "description": "Metodi di pagamento allegati al tuo account",
      "default": "Predefinito",
      "action_edit_remove": "Modifica o rimuovi",
      "action_remove": "Rimuovere",
      "action_default": "Imposta come predefinito",
      "action_fallback": "Imposta come riserva",
      "expires": "Scade",
      "add_new_card": "Aggiungi metodo di pagamento",
      "action_fallback_remove": "Rimuovi dal fallback",
      "fallback": "Ricaderci",
      "action_edit": "Modificare",
      "action_delete": "Eliminare",
      "action_default_remove": "Rimuovi come predefinito",
      "domain_count@@one": "Utilizzato da {{count}} domini",
      "domain_count@@other": "Utilizzato da {{count}} domini"
    },
    "paypal_bind": {
      "button": "Collega il conto PayPal",
      "button_load": "Collegamento...",
      "disconnected": "Non connesso",
      "error": "Si è verificato un errore",
      "success_header": "Successo",
      "success_no_promo": "Il tuo conto PayPal è ora collegato",
      "success": "Il tuo conto PayPal è ora collegato, verranno detratti $ 5 dalla tua prossima fattura!"
    },
    "card_add": {
      "header": "Aggiungi nuova carta",
      "success": "Connessa una nuova carta a Linguise!",
      "terms": "Fornendo i dati della tua carta, consenti a Linguise di addebitare sulla tua carta pagamenti futuri secondo i nostri termini di servizio."
    },
    "card_detail": {
      "header": "Informazioni sulla carta",
      "delete": {
        "error": "Non puoi eliminare questo metodo di pagamento perché ha un abbonamento attivo!"
      }
    },
    "subscriptions": {
      "table": {
        "description": "Abbonamenti con questo metodo di pagamento",
        "header_domain": "Dominio",
        "header_plan": "Piano",
        "header_status": "Stato",
        "header_actions": "Azioni",
        "cancelling": "Annullamento alle: {{0}}",
        "next_payment": "Prossimo pagamento a: {{0}}",
        "action_renew": "Rinnovare",
        "no_subs_header": "Nessun abbonamento da mostrare",
        "no_subs_desc": "Una volta effettuata l'iscrizione a questa carta, tutte le informazioni verranno visualizzate qui",
        "action_manage": "Maneggio"
      },
      "status": {
        "active": "Attivo",
        "canceled": "Annullato",
        "incomplete": "Non pagato",
        "incomplete_expired": "Non pagato (scaduto)",
        "past_due": "Scaduto",
        "trialing": "Prova",
        "unpaid": "Non pagato",
        "missing": "Errore"
      }
    },
    "delete_confirm_body": "Sei sicuro di voler eliminare questo metodo di pagamento? Questa azione non può essere annullata!",
    "delete_confirm_header": "Eliminare il metodo di pagamento?",
    "card_edit": {
      "header": "Modifica carta",
      "billing_header": "Informazioni di fatturazione",
      "address_error": "L'indirizzo è obbligatorio!",
      "card_number": "Numero della carta",
      "card_expiry": "Data di scadenza",
      "expiry_error_month": "Mese fornito non valido",
      "expiry_error_year": "Anno fornito non valido",
      "expiry_error_expired": "L'anno di scadenza della tua carta è passato.",
      "card_header": "Informazioni sulla carta",
      "expiry_error_empty": "Questo campo è obbligatorio!"
    }
  },
  "plans": {
    "per": "per",
    "wordsTranslated": "parole tradotte",
    "current": "Corrente",
    "archived": "Archiviato",
    "day": "giorno",
    "week": "settimana",
    "month": "mese",
    "year": "anno",
    "activate": "Attiva",
    "cancel": "Cancella",
    "change": "Cambia",
    "upgrade": "Passa a un piano superiore",
    "downgrade": "Passa a un piano inferiore",
    "notEnoughWords": "Non abbastanza parole",
    "yearIntervalOnly": "Non si può migrare dal piano annuale",
    "wordsUnlimited": "Parole illimitate",
    "tabs": {
      "day": "Prezzi quotidiani",
      "week": "Prezzi settimanali",
      "month": "Prezzi mensili",
      "year": "Prezzi annuali",
      "sub_texts": {
        "day": "Un prezzo fisso, tutti i giorni",
        "week": "Un prezzo fisso, ogni settimana",
        "month": "Un prezzo fisso, ogni mese",
        "year": "Un mese gratis, una fattura all'anno"
      }
    },
    "details": {
      "new_languages": "Aggiungi nuove lingue in qualsiasi momento",
      "one_month_trial": "Un mese di prova gratuita per ogni nuovo sito web",
      "multi_content_indexed": "100% dei contenuti multilingue indicizzati",
      "translate_new_content": "Traduci istantaneamente nuovi contenuti",
      "free_installation": "Installazione e configurazione gratuite",
      "compared_monthly_plan": "Un mese gratis rispetto ai piani mensili",
      "risk_free_recurring": "Fallimenti di pagamento ricorrenti senza rischi",
      "unlimited_languages": "Lingue e visualizzazioni di pagina illimitate",
      "high_server_resources": "Elevate risorse del server",
      "billed": {
        "day": "Fatturato giornalmente",
        "week": "Fatturazione settimanale",
        "month": "Fatturazione mensile",
        "year": "Fatturato annualmente"
      },
      "request_max_size": "Dimensione massima richiesta {{0}}"
    },
    "frequent_question": {
      "title": "Domande frequenti",
      "questions": {
        "trial": {
          "question": "Posso utilizzare la prova su un nuovo dominio del sito web?",
          "answer": "Sì, offriamo una prova gratuita di 30 giorni per ogni nuovo dominio del sito web che aggiungi al tuo account. In questo modo potrai testare appieno il servizio di traduzione sul tuo nuovo sito web."
        },
        "seo": {
          "question": "Quanto tempo occorre affinché il mio SEO migliori?",
          "answer": "I contenuti e i contenuti multilingue richiedono tempo per essere completamente indicizzati e ben classificati. A seconda del traffico e delle dimensioni del tuo sito web, sono necessarie dalle 3 alle 6 settimane."
        },
        "quota": {
          "question": "Le traduzioni umane sono incluse nella quota?",
          "answer": "No, il limite del conteggio delle parole riguarda solo le traduzioni automatiche. Un traduttore può modificare manualmente le traduzioni automatiche senza limiti."
        }
      }
    },
    "best_offer": "Migliore offerta",
    "resume": "Riprendere",
    "subsCanceled": "È in corso un'altra cancellazione dell'abbonamento",
    "period": {
      "days@@one": "giorno",
      "days@@other": "{{count}} giorni",
      "hours@@one": "ora",
      "hours@@other": "{{count}} ore",
      "minutes@@one": "minuto",
      "minutes@@other": "{{count}} minuti",
      "seconds@@one": "secondo",
      "seconds@@other": "{{count}} secondi"
    },
    "words": {
      "billion": "{{value}} Mld",
      "million": "{{value}} Mln",
      "thousand": "{{value}} mila"
    },
    "throttling_info": "{{words}} parole al {{period}}"
  },
  "profile": {
    "welcome": "Benvenuto!",
    "account": "Il Mio Account",
    "subscriptions": "Iscrizioni",
    "logout": "Disconnetti"
  },
  "register": {
    "errors": {
      "password": "Minimo 8 caratteri, qualsiasi carattere"
    }
  },
  "route": {
    "dashboard": "Pannello",
    "rules": "Regole",
    "translations": "Traduzioni",
    "search_translations": "Cerca traduzioni",
    "urls_translations": "Traduzioni URL",
    "links": "Media e link esterni",
    "online_editor": "Editor live",
    "settings": "Impostazioni",
    "domain": {
      "finish": "Impostazioni",
      "preconfig": "Impostazioni"
    },
    "home": "Casa",
    "domain_list": "Elenco domini",
    "members": "Membri",
    "invoices": "Fatture",
    "billing": "Dettagli di fatturazione",
    "language_display": "Vengono visualizzate le bandiere della lingua",
    "payment_methods": "Metodi di pagamento",
    "ai_translation": "Traduzione AI",
    "ai_translation_settings": "Impostazioni",
    "ai_translation_pricing": "Prezzi"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "Testo da ignorare",
        "add": "Aggiungi nuovo",
        "title": "Testo da ignorare",
        "description": "Aggiungere uno o più testi da ignorare",
        "ignore_case": "Ignora maiuscole/minuscole"
      },
      "html_content": {
        "title": "Applica al contenuto html",
        "description": "Applica la regola su tutto il tuo contenuto o selezionando un selettore CSS specifico",
        "all_page": "Tutta la pagina",
        "css_selector": "Selettore CSS",
        "label": "Selettore CSS",
        "placeholder": "Selettore da applicare a",
        "add": "Aggiungi nuovo"
      },
      "apply_to_urls": {
        "title": "Applica agli URL",
        "description": "Seleziona gli URL specifici a cui vuoi applicare la regola",
        "all_urls": "Tutti gli URL",
        "selected_urls": "URL selezionati",
        "label": "Url da applicare a",
        "placeholder": "Url da applicare a",
        "original_url": "URL originali",
        "translated_url": "URL tradotti",
        "wildcard": "Jolly",
        "regex": "Espressione regolare",
        "add": "Aggiungi nuovo",
        "expression": "Tipo di espressione"
      },
      "apply_urls": {
        "title_exclude": "Escludi negli URL",
        "title_replace": "Sostituisci negli URL",
        "title_description": "Applica questa regola anche alla traduzione degli URL"
      },
      "apply_languages": {
        "title": "Applica alle lingue",
        "description": "Seleziona la lingua specifica in cui vuoi applicare la regola",
        "all_languages": "Tutte le lingue",
        "selected_languages": "Lingue selezionate",
        "placeholder": "Seleziona lingue...",
        "feedback": "Devi scegliere una lingua"
      },
      "name": {
        "title": "Titolo",
        "description": "Dai un titolo alla tua regola per comodità",
        "placeholder": "Nome regola"
      },
      "type": {
        "title": "Tipo",
        "description": "Scegli il tipo di regola che vuoi aggiungere",
        "text_ignore": "Ignora testo",
        "text_replace": "Sostituisci testo",
        "content_exclusion": "Esclusione del contenuto",
        "ignore_inline": "Ignora in linea",
        "url_exclusion": "Esclusione traduzione url",
        "full_description": {
          "text_ignore": "Aggiungi delle regole per evitare che del testo venga tradotto. Potrebbe essere il nome del tuo prodotto, il nome del marchio o altri elementi tecnici che non vuoi che siano tradotti.",
          "text_replace": "Text replace permette di sostituire del testo con la traduzione desiderata, può essere necessario quando la traduzione ignora il contesto.",
          "content_exclusion": "L'esclusione del contenuto ti aiuterà ad evitare la traduzione di alcuni contenuti nella pagina.\nSe vuoi escludere completamente una pagina dalla traduzione (nessun URL multilingue per questa pagina e nessun contenuto tradotto) usa l'\"esclusione della traduzione degli URL",
          "url_exclusion": "L'esclusione della traduzione delle pagine ti aiuterà a impostare le pagine che non vuoi tradurre",
          "ignore_inline": "Evita di tradurre alcuni contenuti come contenuti in linea, traduci invece ogni tag separatamente."
        }
      },
      "text_replace": {
        "title": "Testo da sostituire",
        "description": "Sostituisci un testo con la tua traduzione specifica. Sostituisci qualsiasi testo in tutte le tue pagine, per linguaâ€¦",
        "text_to_replace": "Testo da sostituire",
        "ignore_case": "Ignora maiuscole/minuscole",
        "text_type": "Sostituzione nella traduzione",
        "text_type_original": "Originale",
        "text_type_translation": "Traduzione",
        "keep_case": "Prova a mantenere maiuscole/minuscole",
        "add": "Aggiungi nuovo"
      },
      "content_exclusion": {
        "title": "Esclusione del contenuto",
        "description": "Seleziona uno o più selettori CSS che non saranno tradotti",
        "label": "Selettore CSS",
        "placeholder": "Selettore da applicare a",
        "add": "Aggiungi nuovo"
      },
      "multilingual_url": {
        "title": "Utilizza URL multlingue",
        "description": "Se impostato Si, l'URL NON sarà tradotto ma la pagina rimarrà multilingue con un contenuto tradotto",
        "live_example_title": "Esempio live",
        "live_example_description": "Fonte URL: https://yourwebsite.com/page-not-translated",
        "live_example_multilingual": "URL generato: https://yourwebsite.com/fr/page-not-translated",
        "live_example_no_multilingual": "URL generato: https://yourwebsite.com/page-not-translated"
      },
      "rule_application": {
        "description": "Applicare la regola sul contenuto statico o sul contenuto dinamico o entrambi",
        "title": "Applicare al contenuto",
        "all": "Tutto il contenuto",
        "static": "Contenuto statico",
        "dynamic": "Contenuto dinamico"
      },
      "force_apply_urls": {
        "title_description": "Force Applica questa regola a tutta la traduzione degli URL, comprese le traduzioni esistenti!",
        "title_replace": "Forza sostituire negli URL",
        "title_exclude": "Forza escludere negli URL",
        "warning": "Avvertimento",
        "warning_part1": "Impostare questo su \"Sì\" potrebbe interrompere le traduzioni URL del tuo sito Web.",
        "warning_part2": "Questo può generare temporaneamente o permanentemente una pagina 404S, continua solo se si comprende le conseguenze.",
        "warning_replacement_original": "Avviso aggiuntivo: stai cercando di sostituire il contenuto originale che potrebbe influire sull'URL, la traduzione potrebbe fallire dal momento che la linguisca non è in grado di trovare correttamente gli URL originali"
      }
    },
    "main": {
      "parent": "Regole",
      "edit": "Modifica regola",
      "add": "Nuova regola"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "\"{{text_ignore}}\" sarà ignorato nel contenuto e nell'URL",
      "preview_single": "\"{{text_ignore}}\" sarà ignorato nel contenuto",
      "preview_more_with_url": "\"{{text_ignore}}\" e {{count}} altro sarà ignorato nel contenuto",
      "preview_more": "\"{{text_ignore}}\" e {{count}} altro saranno ignorati nel contenuto",
      "other_parameters": "Altri parametri sono impostati per questa regola, clicca sul pulsante modifica per avere maggiori informazioni"
    },
    "text_replace": {
      "preview_single_with_url": "\"{{original}}\" è sostituito da \"{{replacement}}\" nel contenuto e negli URL",
      "preview_single": "\"{{original}}\" è sostituito da \"{{replacement}}\" nel contenuto",
      "preview_more_with_url": "\"{{original}}\" è sostituito da \"{{replacement}}\" nel contenuto e negli URL, e {{nb}} altro",
      "preview_more": "\"{{original}}\" è sostituito da \"{{replacement}}\" nel contenuto, e {{nb}} altro",
      "other_parameters": "Per questa regola sono impostati altri parametri, clicca sul pulsante modifica per ottenere maggiori informazioni"
    },
    "content_exclusion": {
      "selectors": "{{nb}} Selettore/i CSS esclusi dalla traduzione",
      "other_parameters": "Altri parametri sono impostati per questa regola, clicca sul pulsante modifica per avere maggiori informazioni"
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}} Gli URL sono esclusi dalla traduzione, ma mantengono il prefisso multilingue",
      "some": "{{nb}} Gli URL sono completamente esclusi dalla traduzione",
      "all_multilingual": "tutti gli URL sono esclusi dalla traduzione, ma mantengono il prefisso multilingue",
      "all": "tutti gli URL sono completamente esclusi dalla traduzione",
      "other_parameters": "Per questa regola sono impostati altri parametri, clicca sul pulsante modifica per avere maggiori informazioni"
    },
    "ignore_inline": {
      "elements": "Tutti i contenuti in linea verranno tradotti come contenuti bloccati nella pagina",
      "all_elements": "Alcuni contenuti in linea verranno tradotti come contenuti bloccati nella pagina",
      "other_parameters": "Per questa regola sono impostati altri parametri, fare clic sul pulsante modifica per ottenere maggiori informazioni"
    },
    "title": "Gestione delle regole",
    "description": "Gestisci le esclusioni e le sostituzioni dei contenuti delle traduzioni in tutto il tuo sito web",
    "add": "Aggiungi nuova regola",
    "table": {
      "title": "Titolo",
      "type": "Tipo",
      "preview": "Anteprima della regola",
      "action": "Azione",
      "delete_confirm": "Conferma l'eliminazione della regola",
      "types": {
        "text_ignore": "Ignora il testo",
        "text_replace": "Sostituisci testo",
        "content_exclusion": "Esclusione del contenuto",
        "url_exclusion": "Esclusione URL",
        "ignore_inline": "Ignora in linea",
        "unknown": "Regola sconosciuta"
      },
      "no_data": "Nessuna regola qui ancora"
    },
    "apply_on_content": {
      "static": "Questa regola verrà applicata solo ai contenuti statici",
      "dynamic": "Questa regola verrà applicata solo ai contenuti dinamici"
    }
  },
  "search_translations": {
    "title": "Gestione delle traduzioni della ricerca",
    "description": "Elenca tutte le traduzioni del tuo sito web utilizzate attraverso i moduli di ricerca (dalla lingua tradotta alla lingua di base del tuo dominio)",
    "filter_languages": "Filtra per lingua...",
    "filter_original": "Filtra testo in lingua originale",
    "filter_translation": "Filtra per testo tradotto",
    "table": {
      "original": "Originale",
      "language": "Lingua",
      "translation": "Traduzione"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "Impossibile iscriversi!",
      "title": "Impossibile iscriversi!",
      "subtitle": "Si è verificato un errore durante il tentativo di elaborare l'abbonamento.",
      "home": "Torna a casa",
      "generic": "Si è verificato un errore sconosciuto sul lato Linguise, contatta l'amministratore!"
    },
    "success": {
      "home": "Gestisci le traduzioni di domini",
      "message": "Ci impegniamo a fornirti la migliore esperienza di traduzione possibile. Il nostro team di esperti è a disposizione per assisterti con qualsiasi domanda o supporto di cui potresti aver bisogno. Per iniziare, è sufficiente fare clic sul pulsante in basso.",
      "subtitle": "Grazie per aver scelto il servizio di traduzione Linguise",
      "title": "Abbonamento attivato!",
      "tab_title": "Grazie per l'iscrizione!"
    }
  },
  "subscriptions": {
    "edit": {
      "title": "Gestisci l'iscrizione"
    },
    "list": {
      "title": "Elenco iscrizioni",
      "description": "Elenco delle tue iscrizioni al dominio"
    },
    "table": {
      "domain": "Dominio",
      "plan": "Piano",
      "status": "Stato",
      "card": "Carta",
      "usage": "Uso",
      "actions": "Azioni",
      "payment_method": "Metodo di pagamento"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} parole",
      "paidOffered": "{{words_used}} / {{words_allowed}} parole\n(Incluse {{free_words}} parole offerte)"
    },
    "success": {
      "tab_title": "Abbonamento attivato!",
      "title": "Abbonamento attivato!",
      "subtitle": "Grazie per aver scelto il servizio di traduzione Linguise",
      "message": "'Ci impegniamo a fornirti la migliore esperienza di traduzione possibile. Il nostro team di esperti è a disposizione per assisterti con qualsiasi domanda o supporto di cui potresti aver bisogno. Per iniziare, è sufficiente fare clic sul pulsante in basso.",
      "home": "Gestisci le traduzioni di domini"
    },
    "popup": {
      "dueToday": "Totale dovuto oggi",
      "nextPeriod": "A partire dal {{date}}"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "Scegli un account"
    }
  },
  "translation": {
    "main": {
      "parent": "Traduzioni",
      "edit": "Modifica traduzione"
    },
    "form": {
      "original": {
        "title": "Originale in {{language}}"
      },
      "is_inline": "Questa traduzione è fatta da contenuti in linea.",
      "inline_editor": {
        "count_warning": "Il numero di aree in linea non corrisponde all’originale ({{current}} su {{expected}}).",
        "restore_original": "Ripristina il testo originale",
        "insert_placeholder": "Inserisci un segnaposto",
        "drag": "Trascina per riordinare l’area",
        "area": "Area inline {{index}}",
        "restore": "Ripristina le aree in linea mancanti"
      },
      "translation": {
        "title": "Traduzione in {{language}}",
        "description": "Traduzione che vuoi sovrascrivere"
      }
    },
    "copy": {
      "title": "Copia nella traduzione manuale",
      "label": "Copia nel manuale"
    },
    "level": {
      "base": {
        "title": "Traduzione di base",
        "subtitle": "Automatica · traduzione Linguise Cloud",
        "empty": "Nessuna traduzione di base per questo testo.",
        "overridden": "La tua scelta è salvata, ma viene mostrata al suo posto la traduzione migliorata con l'AI più recente perché “Sovrascrivi le traduzioni manuali e selezionate” è su Sì nelle impostazioni della traduzione AI. Disattiva questa opzione per usare la tua scelta."
      },
      "not_generated": "Non generata",
      "none": "Ancora nulla",
      "ai": {
        "title": "Traduzione migliorata con l'AI",
        "subtitle": "Automatica · Linguise AI",
        "empty_title": "Non ancora generata per questo testo",
        "empty_description": "Linguise AI offre traduzioni più naturali usando il contesto della pagina e del sito. Per averne una qui:",
        "empty_step_1": "Vai su Traduzione AI › Impostazioni e imposta Abilita la traduzione AI su “Solo regole”, “Solo editor live” o “Regole ed editor live”.",
        "empty_step_2": "Applicala con una regola che corrisponde a questa pagina, oppure attivala pagina per pagina dall'editor live.",
        "empty_step_3": "La traduzione migliorata con l'AI apparirà qui una volta generata. Utilizza i tuoi crediti AI.",
        "open_settings": "Apri le impostazioni della traduzione AI",
        "open_editor": "Apri l'editor live",
        "overrides_selection": "La tua scelta è salvata, ma viene mostrata al suo posto questa traduzione migliorata con l'AI perché “Sovrascrivi le traduzioni manuali e selezionate” è su Sì nelle impostazioni della traduzione AI. Disattiva questa opzione per usare la tua scelta.",
        "overrides_version": "La versione che hai scelto è salvata, ma viene mostrata al suo posto la versione migliorata con l'AI più recente perché “Sovrascrivi le traduzioni manuali e selezionate” è su Sì nelle impostazioni della traduzione AI. Disattiva questa opzione per usare la versione scelta."
      },
      "manual": {
        "title": "Traduzione manuale",
        "subtitle": "Scritta da te · ha la priorità sulle traduzioni automatiche",
        "empty": "Vuota",
        "saved_but_overridden": "Salvata come tua scelta, ma non mostrata automaticamente perché “Sovrascrivi le traduzioni manuali” è su Si nelle impostazioni della traduzione AI: la traduzione migliorata con l'AI prevale finché questa opzione non viene disattivata.",
        "ignored": "Non mostrata automaticamente perché “Sovrascrivi le traduzioni manuali” è su Si nelle impostazioni della traduzione AI. Selezionala per usarla per questo testo.",
        "label": "La tua traduzione",
        "placeholder": "Scrivi la tua traduzione...",
        "last_updated": "Ultima modifica: {{date}}",
        "save_hint": "Salvando una traduzione manuale, questa diventa attiva.",
        "delete": "Elimina traduzione manuale",
        "delete_confirm": "Si prega di confermare l'eliminazione della traduzione manuale"
      }
    },
    "history": {
      "title": "Versioni migliorate con l'AI",
      "subtitle": "Ogni rigenerazione dall'editor live viene conservata",
      "unknown_model": "Modello sconosciuto",
      "current": "Attuale",
      "restore": "Ripristina questa versione",
      "restore_note": "Il ripristino rende quella versione la traduzione migliorata con l'AI attuale. Non viene eliminato nulla.",
      "version_of": "Versione {{current}} di {{total}}",
      "hide": "Nascondi cronologia ({{total}})",
      "show": "Mostra cronologia ({{total}})"
    },
    "choose": {
      "title": "Traduzioni in {{language}} · scegli quella che vedono i visitatori",
      "current": "Attualmente sul tuo sito:",
      "priority": "Priorità predefinita: manuale › migliorata con l'AI › di base. La tua scelta vale solo per questa traduzione.",
      "reset": "Ripristina la priorità predefinita",
      "reset_title": "Dimentica la tua scelta per questo testo e usa di nuovo la priorità predefinita",
      "resetting": "Ripristino ..."
    }
  },
  "translations": {
    "title": "Gestione traduzioni",
    "description": "Elenca e modifica tutte le traduzioni del tuo sito web, per una traduzione visiva usa il Live Editor",
    "filter_languages": "Filtra per lingua...",
    "filter_original": "Filtra testo in lingua originale",
    "filter_translation": "Filtra per testo tradotto",
    "table": {
      "original": "Originale",
      "language": "Lingua",
      "action": "Azione",
      "base": "Di base",
      "ai": "Migliorata AI",
      "manual": "Manuale"
    },
    "filter_exact": "Corrispondenza esatta",
    "badge": {
      "active": "Attiva",
      "overrides_manual": "Sovrascrive manuale"
    },
    "cell": {
      "none": "nessuna",
      "not_generated": "non generata",
      "ignored": "Ignorata – prevale la regola AI"
    },
    "tabs": {
      "all": "Tutte",
      "manual": "Con manuale",
      "ai": "Con AI migliorata",
      "base": "Solo di base"
    },
    "levels_hint": "Ogni testo ha fino a 3 livelli: quello contrassegnato come Attiva è quello che vedono i visitatori."
  },
  "url": {
    "main": {
      "parent": "URLs",
      "edit": "Modifica traduzione URL"
    },
    "form": {
      "original": {
        "title": "Originale in {{language}}"
      },
      "translation": {
        "title": "Traduzione URL in {{language}}",
        "description": "URL che vuoi sovrascrivere",
        "placeholder": "Traduzione Url sovrascritta",
        "invalid_full": "Stai tentando di modificare il formato con un formato errato, dovresti modificare solo gli slug/percorso della traduzione dell'URL",
        "invalid": "URL/percorso fornito non valido"
      }
    }
  },
  "urls": {
    "title": "Gestione URL",
    "description": "Elenca e modifica tutti gli URL del tuo sito web contenuto tradotto (avanzato, attenzione agli errori 404)",
    "filter_languages": "Filtra per lingue...",
    "filter_original": "Filtra test oil lingua originale",
    "filter_translation": "Filtra per testo tradotto",
    "table": {
      "original": "Originale",
      "language": "Lingua",
      "url": "URL Tradotto",
      "action": "Azione",
      "edited": "La traduzione originale è stata modificata"
    }
  }
}
